import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { Error } from '@mui/icons-material'
import { Card as BaseCard } from '@chilecompra/react-kit/components'

export const AlertIcon = styled(Error)`
  color: ${props => props.theme.palette.blue[50]};
  height: auto;
  margin-bottom: 14px;
  width: 32px;
`

export const AlertWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 17px 9px;
`

export const Card = styled(BaseCard)`
  text-align: center;
`

export const Column = styled(({ flexGrow, margin, padding, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-grow: ${props => props.flexGrow ?? ''};
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0 5px'};
    width: ${props => props.width};
  }
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.gray[50]};
  height: auto;
  width: 82px;
`

export const PrimaryLink = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  margin-top: 14px;
  text-decoration: none;
`

export const Row = styled(({ margin, ...props }) => <BaseGrid container {...props} />)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0 -5px'};
    padding: 12px 0 0;
    width: 100%;
  }
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 24px 0;
  overflow: visible;
`

export const Strong = styled('span')`
  font-weight: bold;
`
